import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import vi from "./locales/vi";
import en from "./locales/en";
const resources = {
  vi: {
    translation: vi,
  },
  en: {
    translation: en,
  },
};

export async function loadLanguage(language: string) {
  /** @deprecated Lỗi khi chạy trên native mobile ??? */
  // const addResourcePlatform = () => {
  //   Platform.select({
  //     web: async () => {
  //       if (!i18n.hasResourceBundle(language, "translation")) {
  //         const lng = await import(`./locales/${language}`);
  //         i18n.addResourceBundle("en", "translation", lng.default);
  //       }
  //     },
  //     native: () => {},
  //   });
  // };
  // addResourcePlatform();
  i18n.changeLanguage(language);
}

i18n.use(initReactI18next).init({
  resources,
  lng: "vi",
  supportedLngs: ["en", "vi"],
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  cleanCode: true,
});

export default i18n;
